export default {
  name: 'zh-cn',
  el: {
    breadcrumb: {
      label: '面包屑',
    },
    colorpicker: {
      confirm: '确定',
      clear: '清空',
      defaultLabel: '颜色选择器',
      description: '当前颜色 {color}，按 Enter 键选择新颜色',
      alphaLabel: '选择透明度的值',
      alphaDescription: '透明度 {alpha}, 当前颜色 {color}',
      hueLabel: '选择色相值',
      hueDescription: '色相 {hue}, 当前颜色 {color}',
      svLabel: '选择饱和度与明度的值',
      svDescription: '饱和度 {saturation}, 明度 {brightness}, 当前颜色 {color}',
      predefineDescription: '选择 {value} 作为颜色',
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      dateTablePrompt: '使用方向键与 Enter 键可选择日期',
      monthTablePrompt: '使用方向键与 Enter 键可选择月份',
      yearTablePrompt: '使用方向键与 Enter 键可选择年份',
      selectedDate: '已选日期',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六',
      },
      weeksFull: {
        sun: '星期日',
        mon: '星期一',
        tue: '星期二',
        wed: '星期三',
        thu: '星期四',
        fri: '星期五',
        sat: '星期六',
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月',
      },
    },
    inputNumber: {
      decrease: '减少数值',
      increase: '增加数值',
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择',
    },
    mention: {
      loading: '加载中',
    },
    dropdown: {
      toggleDropdown: '切换下拉选项',
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据',
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页',
      page: '页',
      prev: '上一页',
      next: '下一页',
      currentPage: '第 {pager} 页',
      prevPages: '向前 {pager} 页',
      nextPages: '向后 {pager} 页',
      deprecationWarning:
        '你使用了一些已被废弃的用法，请参考 el-pagination 的官方文档',
    },
    dialog: {
      close: '关闭此对话框',
    },
    drawer: {
      close: '关闭此对话框',
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!',
      close: '关闭此对话框',
    },
    upload: {
      deleteTip: '按 Delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传',
    },
    slider: {
      defaultLabel: '滑块介于 {min} 至 {max}',
      defaultRangeStartLabel: '选择起始值',
      defaultRangeEndLabel: '选择结束值',
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计',
      selectAllLabel: '选择所有行',
      selectRowLabel: '选择当前行',
      expandRowLabel: '展开当前行',
      collapseRowLabel: '收起当前行',
      sortLabel: '按 {column} 排序',
      filterLabel: '按 {column} 过滤',
    },
    tag: {
      close: '关闭此标签',
    },
    tour: {
      next: '下一步',
      previous: '上一步',
      finish: '结束导览',
      close: '关闭此对话框',
    },
    tree: {
      emptyText: '暂无数据',
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项',
    },
    image: {
      error: '加载失败',
    },
    pageHeader: {
      title: '返回',
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    },
    carousel: {
      leftArrow: '上一张幻灯片',
      rightArrow: '下一张幻灯片',
      indicator: '幻灯片切换至索引 {index}',
    },
    inputOTP: {
      groupLabel: '一次性密码输入框',
      defaultLabel: '请输入第 {index} 位 OTP 字符',
    },
  },
}
